import React from 'react';
import shapeIconBottom from '../../images/shapes/shape_2kk_section_bottom.svg';
import { Link } from 'react-scroll'
import { NavLink } from 'react-router-dom'



const Footer = () => {

    const SubmitHandler = (e) => {
        e.preventDefault()
    }
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <footer className="ico_site_footer">
            <div className="container">
                <div className="footer_bottom text-center">
                    <p className="copyright_text m-0 text-secondary" style={{ fontFamily: 'ReMedium' }}>Copyright© 2025. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
